import React, { ReactNode } from 'react'
import { FormControlLabel, Radio, Theme, Checkbox } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import SpeciesCard from './SpeciesCard'

const useStyles = makeStyles((theme: Theme) => {
  const { main, light } = theme.palette.primary
  return {
    speciesSelectionBoxStyle: {
      height: theme.typography.pxToRem(70),
      display: 'flex',
      border: 'solid 1px',
      borderColor: theme.palette.grey[500],
      borderRadius: '5px',
      marginLeft: 0,
      marginRight: 0,
      minWidth: '230px',
    },
    speciesSelectionBoxStyleOnSelected: {
      backgroundColor: light,
      borderColor: main,
      border: 'solid 2px',
    },
    formControlLabelStyle: {
      width: '100%',
      marginLeft: theme.spacing(-2),
    },
  }
})

interface SpeciesSelectionBoxProps {
  name: string
  checked: boolean
  clickHandler?: ({ name, checked }: { name: string; checked: boolean }) => void
  label?: ReactNode
  multiSelect?: boolean
}

const SpeciesSelectionBox: React.FC<SpeciesSelectionBoxProps> = ({
  name,
  checked,
  clickHandler,
  label,
  multiSelect = false,
}) => {
  const classes = useStyles()
  const speciesBoxStyle = clsx(
    classes.speciesSelectionBoxStyle,
    checked && classes.speciesSelectionBoxStyleOnSelected
  )
  const onClick = (e: React.MouseEvent) => {
    if (clickHandler) {
      e.preventDefault()
      clickHandler({
        name: name,
        checked: checked,
      })
    }
  }

  return (
    <FormControlLabel
      classes={{
        root: speciesBoxStyle,
        label: classes.formControlLabelStyle,
      }}
      control={
        multiSelect ? (
          <Checkbox icon={<></>} checkedIcon={<></>} />
        ) : (
          <Radio icon={<></>} checkedIcon={<></>} />
        )
      }
      label={<SpeciesCard name={name} checked={checked} label={label} />}
      value={name}
      onClick={onClick}
    />
  )
}
export default SpeciesSelectionBox
